export const Rules = {
  required: (data, setErrorMessage) => {
    if (typeof data === "number" && (data === "undefined" || data === 0)) {
      setErrorMessage && setErrorMessage("فیلد ضروری");
      return false;
    } else if (data?.toString().trim().length === 0) {
      setErrorMessage && setErrorMessage("فیلد ضروری");
      return false;
    }
    return true;
  },
  len: (data, len, setErrorMessage) => {
    if (data.length !== parseInt(len, 10)) {
      setErrorMessage && setErrorMessage(`طول رشته باید ${len} باشد`);
      return false;
    }
    return true;
  },
  minLength: (data, minLen, setErrorMessage) => {
    if (data.length < parseInt(minLen, 10)) {
      setErrorMessage && setErrorMessage(`طول رشته باید حداقل ${minLen} باشد`);
      return false;
    }
    return true;
  },
  maxLength: (data, maxLen, setErrorMessage) => {
    if (data.length > parseInt(maxLen, 10)) {
      setErrorMessage && setErrorMessage(`طول رشته باید حداکثر ${maxLen} باشد`);
      return false;
    }
    return true;
  },
  email: (data, setErrorMessage) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data)) {
      setErrorMessage && setErrorMessage("فرمت ایمیل نامعتبر است");
      return false;
    }
    return true;
  },
  jalaliDate: (data, setErrorMessage) => {
    const jalaliDateRegex = /^(13|14)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    if (!jalaliDateRegex.test(data)) {
      setErrorMessage && setErrorMessage("تاریخ را انتخاب کنید.");
      return false;
    }
    return true;
  },
  password: (data, setErrorMessage) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!passwordRegex.test(data)) {
      setErrorMessage && setErrorMessage("رمز عبور باید حداقل ۸ کاراکتر باشد و شامل حداقل یک حرف بزرگ، یک حرف کوچک و یک عدد باشد");
      return false;
    }
    return true;
  },
  phoneNumber: (data, setErrorMessage) => {
    const phoneNumberRegex = /^\+?([0-9]{1,4})\)?[-. ]?([0-9]{2,4})[-. ]?([0-9]{3,4})[-. ]?([0-9]{3,4})$/;
    if (!phoneNumberRegex.test(data)) {
      setErrorMessage && setErrorMessage("فرمت شماره تلفن نامعتبر است");
      return false;
    }
    return true;
  },
  alphabetic: (data, setErrorMessage) => {
    const regex = /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C\u200Fa-zA-Z\s]+$/;
    if (!regex.test(data)) {
      setErrorMessage && setErrorMessage("فقط حروف الفبا مجاز هستند");
      return false;
    }
    return true;
  },
  num: (data, setErrorMessage) => {
    const regex = /^[0-9]+$/;
    if (!regex.test(data)) {
      setErrorMessage && setErrorMessage("فقط عدد مجاز است");
      return false;
    }
    return true;
  },
  alphanumeric: (data, setErrorMessage) => {
    const regex = /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C\u200Fa-zA-Z0-9\s]+$/;
    if (!regex.test(data)) {
      setErrorMessage && setErrorMessage("فقط حروف الفبا و عدد مجاز هستند");
      return false;
    }
    return true;
  },
  mobile: (data, setErrorMessage) => {
    const regex = /^09\d{9}$/;
    if (!regex.test(data)) {
      setErrorMessage && setErrorMessage("شماره موبایل وارد شده صحیح نمی‌باشد");
      return false;
    }
    return true;
  },
};